import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { finalize, take } from 'rxjs/operators';
import { Cliente } from 'src/app/modules/painel/modules/clientes/interfaces/cliente';
import { ClienteService } from 'src/app/modules/painel/modules/clientes/services/cliente.service';
import { AlertService } from '../../alert/alert.service';
import { Datatable } from '../../interfaces/datatable';

@Component({
  selector: 'app-clientes-select',
  templateUrl: './clientes-select.component.html',
  styleUrls: ['./clientes-select.component.scss']
})
export class ClientesSelectComponent implements OnInit, OnChanges {

  constructor(
    private fb: FormBuilder,
    private alertService: AlertService,
    public clienteService: ClienteService,
  ) { }

  @Input() clienteId: number;
  private getClientePreSelecionado: boolean = true;

  @Input() id: string = '';
  @Input() label: string = null;
  @Input() placeholder: string = null;
  @Input() form = this.fb.group({});
  @Input() control: string = '';
  @Input() multiple: boolean = false;
  @Input() readonly: boolean = null;
  @Input() disabled: boolean = null;
  @Input() required: boolean = null;

  @Input('myModel') modelInput: any;
  @Output('myModelChange') onChange: EventEmitter<Cliente> = new EventEmitter();

  paginacaoClientes: Datatable<Cliente> = {
    current_page: 1,
    per_page: '50',
    data: []
  };
  loading: boolean = false;
  searchString: string = '';
  private timeoutSearch;

  ngOnInit() {
    this.getClientes(false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.clienteId && changes.clienteId.currentValue)
      this.getCliente();
  }

  get isForm() {
    return this.control !== '';
  }

  getClientes(nextPage: boolean = true) {
    this.loading = nextPage;

    const camposPesquisa = {
      nome_fantasia: this.searchString || null,
      codigo: this.searchString || null,
      cnpj: this.searchString || null
    };

    const paginacaoConfig = {
      items_per_page: this.paginacaoClientes.per_page,
      page: this.paginacaoClientes.current_page + (nextPage ? 1 : 0),
      search: btoa(JSON.stringify(camposPesquisa))
    };

    this.clienteService.getAllPaginated(paginacaoConfig)
      .pipe(take(1), finalize(() => this.loading = false))
      .subscribe(paginacaoClientes => {
        const clientes = nextPage || !this.paginacaoClientes.data.length ? [...this.paginacaoClientes.data, ...paginacaoClientes.data] : this.paginacaoClientes.data;

        this.paginacaoClientes = { ...paginacaoClientes, data: clientes };

        if (this.clienteId && this.getClientePreSelecionado)
          this.getCliente();
      }, (error: HttpErrorResponse) => {
        this.alertService.error(error.error, error.status);
      });
  }

  private getCliente() {
    if (this.clienteId) {
      this.getClientePreSelecionado = false;

      if (this.isForm)
        this.form.get(this.control).setValue(this.clienteId);
      else
        this.modelInput = this.clienteId;

      if (this.paginacaoClientes.data.findIndex(cliente => cliente.id === this.clienteId) === -1) {
        this.loading = true;

        this.clienteService.getById(this.clienteId)
          .pipe(take(1))
          .subscribe(cliente => {
            this.paginacaoClientes.data = [...this.paginacaoClientes.data, cliente];

            this.emitChangeEvent();

            this.loading = false;
          });
      }
      else
        this.emitChangeEvent();
    }
  }

  emitChangeEvent() {
    const clienteId = this.isForm ? this.form.get(this.control).value : this.modelInput;

    if (clienteId)
      this.onChange.emit(this.paginacaoClientes.data.find(cliente => cliente.id === clienteId));
    else
      this.onChange.emit(null);
  }

  searchTyping(searchString: string) {
    this.loading = true;

    this.paginacaoClientes.data = [];
    this.paginacaoClientes.current_page = 1;

    if (this.timeoutSearch) {
      clearTimeout(this.timeoutSearch);
      this.timeoutSearch = null;
    }

    this.timeoutSearch = setTimeout(() => {
      this.searchString = searchString;

      this.getClientes(false);

      clearTimeout(this.timeoutSearch);
      this.timeoutSearch = null;
    }, 500);
  }
}
